/** Stays within the server-side cap on `/report/entries/`. */
export const ENTRY_PANEL_PAGE_SIZE = 8
export const ENTRY_PANEL_SHIMMER_ROW_COUNT = ENTRY_PANEL_PAGE_SIZE
